export default __webpack_public_path__ + "static/media/estruturas.a6e1731c.jpg";